<template>
    <a v-if="hasUpload" v-b-modal="modalId" href="#"
        class="patient-uploaded-document-link"
        :title="`View ${label}`">
        <span class="patient-uploaded-document-label-row">
            <span class="patient-uploaded-document-label">{{ label }}</span>
            <i class="fas fa-eye patient-uploaded-document-icon" aria-hidden="true"></i>
        </span>
        <small class="text-muted patient-uploaded-document-date">
            Uploaded {{ uploadedDisplay }}
        </small>
    </a>
</template>

<script lang="ts">
import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import moment from 'moment';

@Component({
    name: 'PatientUploadedDocumentLink',
})
export default class PatientUploadedDocumentLink extends Vue {
    @Prop({ required: true }) label!: string;
    @Prop({ required: true, default: null }) uploadedDate!: Date | string | null;
    @Prop({ required: true }) modalId!: string;

    get hasUpload(): boolean {
        return !!this.uploadedDate && moment(this.uploadedDate).isValid();
    }

    get uploadedDisplay(): string {
        return moment(this.uploadedDate).fromNow();
    }
}
</script>

<style scoped>
.patient-uploaded-document-link {
    display: block;
    padding: 6px 0;
    text-decoration: none;
    color: inherit;
}
.patient-uploaded-document-link + .patient-uploaded-document-link {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.patient-uploaded-document-label-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.patient-uploaded-document-label {
    color: var(--primary, #007bff);
    text-decoration: underline;
    font-weight: 600;
}
.patient-uploaded-document-icon {
    color: var(--primary, #007bff);
    font-size: 0.95rem;
    opacity: 0.75;
    transition: opacity 0.15s ease, color 0.15s ease;
}
.patient-uploaded-document-link:hover .patient-uploaded-document-label,
.patient-uploaded-document-link:focus .patient-uploaded-document-label,
.patient-uploaded-document-link:hover .patient-uploaded-document-icon,
.patient-uploaded-document-link:focus .patient-uploaded-document-icon {
    color: #0056b3;
    opacity: 1;
}
.patient-uploaded-document-date {
    display: block;
    line-height: 1.2;
    margin-top: 2px;
}
</style>
